exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes spin {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n.GlobalLoader {\n  display: none;\n  width: 100%;\n  height: 100%;\n  background: #00000070;\n  position: fixed;\n  top: 0;\n  z-index: 50;\n  left: 0; }\n  .GlobalLoader .ModalLoader {\n    top: 30%; }\n  .GlobalLoader--Open {\n    display: block; }\n", ""]);

// exports
